import React, { FC } from 'react';
import ButtonGroup from '../ButtonGroup';
import View from '../View';
import {
  FontAwesome,
  Ionicons,
  MaterialCommunityIcons,
} from '@expo/vector-icons';
import { purple, iconGrey, white } from '../../../constants/palette';
import styles from './styles';

// FIXME: The icon set is breaking Storybook

export type SpotifyInteractionPanelProps = {
  isFollowing?: boolean;
  isPlaying: boolean;
  onNextClick: (e: any) => void;
  onPlayClick: (e: any) => void;
  restartTrack: () => void;
  skipTrackEnabled: boolean;
};

export const SpotifyInteractionPanel: FC<SpotifyInteractionPanelProps> = (
  props,
) => {
  const {
    isPlaying,
    onNextClick,
    onPlayClick,
    restartTrack,
    skipTrackEnabled,
  } = props;
  return (
    <ButtonGroup direction="row" style={styles.buttonGroup}>
      <View style={styles.mainContainer}>
        <View style={styles.restartButton}>
          <MaterialCommunityIcons
            name="restart"
            size={30}
            color={white}
            onPress={restartTrack}
          />
        </View>
        <View style={styles.playButton}>
          {isPlaying ? (
            <FontAwesome
              name="pause-circle"
              size={50}
              color={purple}
              onPress={onPlayClick}
            />
          ) : (
            <FontAwesome
              name="play-circle"
              size={50}
              color={purple}
              onPress={onPlayClick}
            />
          )}
        </View>
        {skipTrackEnabled ? (
          <View style={styles.skipButton}>
            <Ionicons
              name="play-skip-forward-sharp"
              size={30}
              color={white}
              onPress={onNextClick}
            />
          </View>
        ) : (
          <View style={styles.skipButton}>
            <Ionicons
              name="play-skip-forward-sharp"
              size={30}
              color={iconGrey}
            />
          </View>
        )}
      </View>
    </ButtonGroup>
  );
};

export default SpotifyInteractionPanel;
